<template>
  <div class="return-quality-records">
    <el-card shadow="never">
      <div slot="header" class="card-header">
        <span>退货质检记录</span>
        <el-button
          type="text"
          @click="$router.push({ name: 'returnQualityInspectionWorkbench' })"
        >
          返回质检工作台
        </el-button>
      </div>
      <el-form inline @submit.native.prevent>
        <el-form-item label="运单号">
          <el-input
            v-model.trim="filterObj.returnMailNo"
            clearable
            placeholder="请输入退回运单号"
            style="width: 280px"
            @keyup.enter.native="search"
          />
        </el-form-item>
        <el-form-item label="结果">
          <el-select
            v-model="filterObj.conclusion"
            clearable
            placeholder="全部"
          >
            <el-option label="质检完成" value="COMPLETED" />
            <el-option label="已拒单" value="REJECTED" />
          </el-select>
        </el-form-item>
        <el-form-item label="完成时间">
          <el-date-picker
            v-model="filterObj.completedAtRange"
            type="datetimerange"
            value-format="yyyy-MM-dd HH:mm:ss"
            :default-time="['00:00:00', '23:59:59']"
            range-separator="至"
            start-placeholder="开始时间"
            end-placeholder="结束时间"
          />
        </el-form-item>
        <el-form-item>
          <el-button type="primary" :loading="querying" @click="search">
            查询
          </el-button>
          <el-button @click="reset">重置</el-button>
          <el-button
            :disabled="!records.length"
            :loading="exporting"
            @click="exportRecords"
          >
            导出
          </el-button>
        </el-form-item>
      </el-form>
    </el-card>

    <el-card class="section-card" shadow="never">
      <el-table v-loading="querying" :data="records" border size="small">
        <el-table-column type="expand">
          <template slot-scope="{ row }">
            <el-table
              v-if="row.items && row.items.length"
              :data="row.items"
              border
              size="mini"
            >
              <el-table-column label="料号" min-width="100">
                <template slot-scope="{ row: detail }">{{
                  detail.itemNo || "-"
                }}</template>
              </el-table-column>
              <el-table-column label="产品名称" min-width="120">
                <template slot-scope="{ row: detail }">{{
                  detailProductName(detail)
                }}</template>
              </el-table-column>
              <el-table-column
                prop="physicalBarcode"
                label="实物条码"
                min-width="120"
              />
              <el-table-column
                prop="expectedQuantity"
                label="应检数量"
                width="100"
                align="right"
              />
              <el-table-column
                prop="scannedQuantity"
                label="已扫数量"
                width="100"
                align="right"
              />
            </el-table>
            <div v-else class="detail-empty">暂无质检明细</div>
          </template>
        </el-table-column>
        <el-table-column
          prop="returnMailNo"
          label="退回运单号"
          min-width="150"
        />
        <el-table-column
          prop="originMerchantOrderNo"
          label="渠道单号"
          min-width="170"
        />
        <el-table-column prop="customerCode" label="货主" min-width="140" />
        <el-table-column label="质检结论" width="110">
          <template slot-scope="{ row }">
            <el-tag :type="statusTagType(row)">{{
              conclusionText(row)
            }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column label="原单关联" width="100">
          <template slot-scope="{ row }">
            <el-tag
              :type="row.relationStatus === 'RELATED' ? 'success' : 'info'"
            >
              {{ relationText(row) }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column
          prop="rejectionReason"
          label="拒单原因"
          min-width="180"
        />
        <el-table-column label="操作人" width="100">
          <template slot-scope="{ row }">{{
            row.operatorName || row.operatorId || "-"
          }}</template>
        </el-table-column>
        <el-table-column label="完成时间" min-width="180">
          <template slot-scope="{ row }">{{
            formatTime(row.completedAt)
          }}</template>
        </el-table-column>
      </el-table>
      <el-pagination
        :current-page="pagination.currentPage"
        :page-sizes="pagesize"
        :page-size="pagination.pageSize"
        :total="pagination.totalCount"
        layout="total, sizes, prev, pager, next, jumper"
        class="table-pagination"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      />
    </el-card>
  </div>
</template>

<script>
import * as XLSX from "xlsx";
import danding from "@/api/danding";
import Page from "@/mixin/Page";

export default {
  name: "ReturnQualityInspectionRecords",
  mixins: [Page],
  data() {
    return {
      filterObj: {
        returnMailNo: "",
        conclusion: "",
        completedAtRange: []
      },
      records: [],
      querying: false,
      exporting: false
    };
  },
  mounted() {
    this.fetch();
  },
  methods: {
    async fetch() {
      this.querying = true;
      try {
        const result = await danding.pageQueryReturnQualityInspections({
          request: {
            ...this.queryFilters(),
            pageIndex: this.pagination.currentPage,
            pageSize: this.pagination.pageSize
          }
        });
        this.records =
          result && Array.isArray(result.items) ? result.items : [];
        const page = (result && result.page) || {};
        this.pagination = {
          currentPage: page.pageIndex || 1,
          pageSize: page.pageSize || this.pagination.pageSize,
          totalCount: page.totalCount || 0
        };
      } finally {
        this.querying = false;
      }
    },
    async exportRecords() {
      if (!this.records.length) {
        return;
      }
      this.exporting = true;
      try {
        const records = await this.fetchAllRecords();
        const data = [
          [
            "退回运单号",
            "渠道单号",
            "货主",
            "料号",
            "产品名称",
            "实物条码",
            "应检数量",
            "已扫数量",
            "质检结论",
            "原单关联",
            "拒单原因",
            "操作人",
            "完成时间"
          ],
          ...this.buildExportRows(records)
        ];
        const workBook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(
          workBook,
          XLSX.utils.aoa_to_sheet(data),
          "退货质检记录"
        );
        XLSX.writeFile(workBook, "退货质检记录列表.xlsx");
        this.$message.success("导出成功");
      } finally {
        this.exporting = false;
      }
    },
    async fetchAllRecords() {
      const pageSize = 100;
      const filters = this.queryFilters();
      const loadPage = pageIndex =>
        danding.pageQueryReturnQualityInspections({
          request: {
            ...filters,
            pageIndex,
            pageSize
          }
        });
      const firstPage = await loadPage(1);
      const records =
        firstPage && Array.isArray(firstPage.items)
          ? firstPage.items.slice()
          : [];
      const totalCount =
        Number(firstPage && firstPage.page && firstPage.page.totalCount) ||
        records.length;
      for (
        let pageIndex = 2;
        pageIndex <= Math.ceil(totalCount / pageSize);
        pageIndex += 1
      ) {
        const page = await loadPage(pageIndex);
        if (page && Array.isArray(page.items)) {
          records.push(...page.items);
        }
      }
      return records;
    },
    buildExportRows(records = this.records) {
      return records.reduce((rows, record) => {
        const details =
          record.items && record.items.length ? record.items : [null];
        details.forEach(detail => {
          rows.push([
            record.returnMailNo || "",
            record.originMerchantOrderNo || "",
            record.customerCode || "",
            detail ? detail.itemNo || "" : "",
            detail ? this.detailProductName(detail) : "",
            detail ? detail.physicalBarcode || "" : "",
            detail ? detail.expectedQuantity : "",
            detail ? detail.scannedQuantity : "",
            this.conclusionText(record),
            this.relationText(record),
            record.rejectionReason || "",
            record.operatorName || record.operatorId || "",
            this.formatTime(record.completedAt)
          ]);
        });
        return rows;
      }, []);
    },
    queryFilters() {
      const range = this.filterObj.completedAtRange || [];
      return {
        returnMailNo: this.filterObj.returnMailNo.trim(),
        conclusion: this.filterObj.conclusion,
        gmtCreateStart: range[0] || "",
        gmtCreateEnd: range[1] || ""
      };
    },
    detailProductName(detail) {
      return Number(detail.expectedQuantity) === 0 && !detail.itemNo
        ? "非本单商品"
        : detail.skuName || "-";
    },
    conclusionText(record) {
      return record.conclusion === "COMPLETED" ? "质检完成" : "已拒单";
    },
    relationText(record) {
      return record.relationStatus === "RELATED" ? "已关联" : "未关联";
    },
    statusTagType(record) {
      return record.conclusion === "COMPLETED" ? "success" : "danger";
    },
    formatTime(timestamp) {
      if (!timestamp) {
        return "-";
      }
      const date = new Date(Number(timestamp));
      return Number.isNaN(date.getTime())
        ? "-"
        : date.toLocaleString("zh-CN", { hour12: false });
    }
  }
};
</script>

<style lang="scss" scoped>
.return-quality-records {
  padding: 16px;

  .section-card {
    margin-top: 16px;
  }

  .card-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  .table-pagination {
    margin-top: 20px;
    text-align: right;
  }

  .detail-empty {
    color: #909399;
    text-align: center;
  }
}
</style>
